import React from "react";
import { Container, Grid } from "@mui/material";

import Menu from '../../Components/Menu'

import page404 from '../../images/page404.png'

const PageNotFound = () => {
  return (
    <div>
      <Menu />
      <Container maxWidth="lg">
      <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="py-5"
          style={{height: '100vh'}}
      >
          <Grid
              xs={12}
              className="text-center"
          >
          <img src={page404} style={{width: '100%', maxWidth: 500, height: 'auto'}} />
          </Grid>
          <Grid
              xs={12}
              className="text-center"
          >
          <h3 className="text-dark">This page could not be found</h3>
          </Grid>
      </Grid>
      </Container>
    </div>
  );
}

export default PageNotFound;
